import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss'
})
export class ToastComponent {
  @Input() message: string = '';
  @Input() position?: 'bottom-left' | 'bottom-center' = 'bottom-left';
  @Input() index: number = 0;
  @Input() translationParams: { [key: string]: any } = {};
  @Input() successToast: boolean = false;
  @Input() errorToast: boolean = false;
  @Output() removeToastIndex: EventEmitter<number> = new EventEmitter<number>();

  constructor() { }

  ngOnInit() { }

  addShowClass() {
    const toastElement = document.getElementById(`toast-${this.message}`);
    if (toastElement) {
      toastElement.classList.add('show');
    }
  }

  closeToast(index?: any) {
    this.removeToastIndex.emit(index);
  }
}
